import Copy from '@nib-components/copy';
import { Columns, Column, Box } from '@nib/layout';
import React from 'react';
const MedicareOption = _ref => {
  let {
    Icon,
    label
  } = _ref;
  return React.createElement(Columns, {
    space: 3,
    verticalAlign: "center"
  }, React.createElement(Column, {
    width: "content"
  }, React.createElement(Box, {
    display: "flex"
  }, React.createElement(Icon, null))), React.createElement(Column, null, React.createElement(Copy, null, label)));
};
export default MedicareOption;